import { BaseIndexRowModel, ProcessStatus } from '../../data';

export interface TransactionalEmailActivityRequestModel {
  scheduledTimestamp?: Date;
  name: string;
  emailFrom: string;
  emailFromName: string;
  mailServerId?: number | null;
  emailSubject: string;
  emailContent: string;
  emailMjmlContent: string;
  status: ProcessStatus;
  sendWhatsAppMessage: boolean;
  htmlTemplateName?: string;
  htmlTemplateContent?: string;
  sftp?: boolean;
  sftpPath?: string;
  indexRows: BaseIndexRowModel[];
}
